/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {formatDate} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FabMessageService} from '@fabric/components/message';
import {DISMISS_MSG} from '../../../common/constants';
import {StateService} from '../../../core/state/state.service';
import {ExcelExportService} from '../../../services/excel-export.service';
import {ReportService} from '../../../services/report.service';

@Component({
    selector: 'app-eng-tran-dtl-rpt',
    templateUrl: './eng-tran-dtl-rpt.component.html',
    styleUrl: './eng-tran-dtl-rpt.component.scss',
    standalone: false
})
export class EngTranDtlRptComponent implements OnInit {
  showSpinner: boolean;

  constructor(protected readonly stateService: StateService,
              protected readonly reportService: ReportService,
              protected readonly excelService: ExcelExportService,
              public snackBar: FabMessageService) {
  }

  ngOnInit() {
    this.showSpinner = false;
  }

  /**
   * Gets the engine transmission detail report
   */
  async getReport() {
    this.showSpinner = true;
    const currDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    const fileName = 'EngineTransmissionDetail_' + currDate;
    try {
      const fileData = await this.reportService.getEngTranDtlReport().toPromise();
      this.excelService.exportToExcelFromServer(fileData, fileName);
    } catch {
      this.snackBar.displayError('Error downloading the report', DISMISS_MSG);
    } finally {
      this.showSpinner = false;
    }
  }
}
